import api from '@/api'

const state = {
  courier: [],
  courierDetail: {},
  balanceList: []
}
const actions = {
  getCourier({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.courier.courierList(params).then(
        response => {
          commit('setCourier', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  createCourier({ _ }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.courier.createCourier(payloads).then(
        response => {
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getCourierDetail({ commit }, { courierId }) {
    return new Promise((resolve, reject) => {
      api.courier.courierDetail(courierId).then(
        response => {
          commit('setCourierDetail', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  },
  getCourierBalance({ commit }, { params }) {
    return new Promise((resolve, reject) => {
      api.courier.balanceList(params).then(
        response => {
          commit('setBalanceList', response.data.data)
          resolve(response)
        },
        error => {
          reject(error)
        }
      )
    })
  }
}
const mutations = {
  setCourier(state, value) {
    state.courier = value
  },
  setCourierDetail(state, value) {
    state.courierDetail = value
  },
  setBalanceList(state, value) {
    state.balanceList = value
  }
}
const getters = {
  courier: state => state.courier,
  courierDetail: state => state.courierDetail,
  balanceList: state => state.balanceList
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
